// extracted by mini-css-extract-plugin
export default {"tosContainer":"TOS_tosContainer__UFcth","tosTitle":"TOS_tosTitle__hV1xf","item":"TOS_item__A3nw7","tosMargin":"TOS_tosMargin__BeKeX","tosImage":"TOS_tosImage__CMo-U"};